var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathProfileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.851,
    height: 74.754,
    viewBox: "0 0 75.851 74.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acb1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8294c4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4-32.4c6.9,1.2,14.2,4.7,16,10.5S34.6-8.1,32.5-1.2c-2.1,6.8-2.7,12.5-4,19.1s-3.4,14.2-8.3,18.9A18.8,18.8,0,0,1,1.3,40.9C-5,38.6-9.9,32.2-16.8,28.6c-6.9-3.5-15.6-4.1-19.5-8.4S-39.1,7.9-37.5.9a64.646,64.646,0,0,1,7-18.5c3.1-5.6,7.3-10.5,12.5-12.7C-12.7-32.4-6.4-31.7.2-32,6.7-32.2,13.4-33.5,20.4-32.4Z",
    transform: "translate(38.963 32.837)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathProfileLogo);
export default __webpack_public_path__ + "static/media/Path-Profile_logo.95662bc56697cca31a6eaa0061752ad4.svg";
export { ForwardRef as ReactComponent };